import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Trophy, Users, Calendar, Target } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const TennisPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header scrollY={100} />
      
      <div className="pt-24 pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center text-green-600 hover:text-green-700 mb-8 transition-colors">
            <ArrowLeft className="w-5 h-5 mr-2" />
            Retour à l'accueil
          </Link>
          
          <div className="mb-12">
            <h1 className="text-5xl font-bold text-gray-900 mb-4">
              Tennis
            </h1>
            <p className="text-xl text-gray-600">
              Nos installations de tennis au TC Cheyres-Châbles
            </p>
          </div>

          {/* Image des courts */}
          <div className="mb-16 rounded-3xl overflow-hidden shadow-2xl">
            <img 
              src="https://customer-assets.emergentagent.com/job_tennis-cheyres/artifacts/656cl4ac_WhatsApp%20Image%202025-10-11%20at%2011.23.28.jpeg"
              alt="Courts de tennis TC Cheyres-Châbles"
              className="w-full h-96 object-cover"
            />
          </div>

          {/* Section principale */}
          <div className="bg-gradient-to-br from-green-50 to-emerald-50 p-10 rounded-3xl mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">2 Courts de tennis synthétiques</h2>
            <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed">
              <p className="text-xl mb-6">
                Le TC Cheyres-Châbles dispose de <strong>2 courts de tennis en surface synthétique</strong>, 
                offrant des conditions de jeu optimales presque toute l'année.
              </p>
              
              <h3 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Avantages des courts synthétiques</h3>
              <ul className="space-y-3">
                <li>🌤️ <strong>Jouez par tous les temps</strong> - Dès que le soleil se fait sentir, les courts sont praticables</li>
                <li>💧 <strong>Séchage rapide</strong> - Reprenez le jeu rapidement après la pluie</li>
                <li>🎾 <strong>Confort de jeu</strong> - Surface douce pour les articulations</li>
                <li>📅 <strong>Saison prolongée</strong> - Jouez plus longtemps dans l'année</li>
                <li>🔧 <strong>Entretien facilité</strong> - Surface durable et résistante</li>
              </ul>

              <h3 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Mini-court gratuit</h3>
              <p className="text-lg">
                En plus des 2 courts principaux, le club met à disposition un <strong>mini-court gratuit</strong>, 
                parfait pour les jeunes joueurs qui souhaitent s'entraîner ou pour tous ceux qui veulent 
                simplement s'amuser en famille !
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TennisPage;
